import { type UseFormReturn } from 'react-hook-form';
import * as z from 'zod';

import { AttachmentSchema } from '#packages/data-collection/models/common/attachment';
import { AuditWindowsFormEntrySchema } from '#packages/data-collection/models/audit-windows-form';

const FormAttachmentSchema = AttachmentSchema.extend({
  file: z.instanceof(File),
});

export const EditAuditFormWindowsEntryDataSchema =
  AuditWindowsFormEntrySchema.omit({
    attachments: true,
  }).extend({
    attachments: z.array(FormAttachmentSchema).optional(),
  });

export type EditAuditFormWindowsEntryData = Omit<
  z.infer<typeof EditAuditFormWindowsEntryDataSchema>,
  | 'quantity'
  | 'widthInFeet'
  | 'widthInInches'
  | 'heightInFeet'
  | 'heightInInches'
  | 'widthInMeters'
  | 'heightInMeters'
> & {
  quantity?: string;
  widthInFeet?: string;
  widthInInches?: string;
  heightInFeet?: string;
  heightInInches?: string;
  widthInMeters?: string;
  heightInMeters?: string;
};

export type EditAuditFormWindowsEntry =
  UseFormReturn<EditAuditFormWindowsEntryData>;
